import { setup } from 'xstate';

export enum ResetPasswordStates {
  Initializing = 'initializing',
  ConfirmResetPassword = 'confirmResetPassword',
  ResetPassword = 'resetPassword',
  EmailSentMessage = 'emailSentMessage',
}

export enum ResetPasswordEvents {
  EmailSent = 'EMAIL_SENT',
}

export const resetPasswordMachine = setup({
  types: {
    context: {} as { email: string | null; code: string | null },
    input: {} as { email: string | null; code: string | null },
  },
  guards: {
    hasEmailAndCode: ({ context }) => !!context.email && !!context.code,
  },
}).createMachine({
  id: 'resetPasswordFlow',
  initial: ResetPasswordStates.Initializing,
  context: ({ input }) => ({
    email: input.email,
    code: input.code,
  }),
  states: {
    [ResetPasswordStates.Initializing]: {
      always: [
        {
          target: ResetPasswordStates.ConfirmResetPassword,
          guard: 'hasEmailAndCode',
        },
        { target: ResetPasswordStates.ResetPassword },
      ],
    },
    [ResetPasswordStates.ConfirmResetPassword]: {
      on: {
        [ResetPasswordEvents.EmailSent]: ResetPasswordStates.EmailSentMessage,
      },
    },
    [ResetPasswordStates.ResetPassword]: {
      on: {
        [ResetPasswordEvents.EmailSent]: ResetPasswordStates.EmailSentMessage,
      },
    },
    [ResetPasswordStates.EmailSentMessage]: {},
  },
});
